import "./App.css";
import Navbar from "./components/common/Navbar";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Footer from "./components/common/Footer";
import SignupPage from "./pages/Signup";
import IELTSHome from "./pages/IELTSHome";

function App() {
  return (
    <div className="App">
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/ielts" element={<IELTSHome />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
